<script setup lang="ts">
import RadioButton from 'primevue/radiobutton';
import type { IElement } from '~/interfaces/form/formBuilder';
import { radioButtonPassthrough } from '~/components/passthroughs/radiobutton';
defineProps<{
  element: IElement;
}>();
const { $t } = useNuxtApp();
const model = defineModel<string>();
const site = useSiteStore();
</script>

<template>
  <div class="flex flex-nowrap gap-4 w-full overflow-hidden">
    <div
      v-for="option in element.items"
      :key="option.label"
      class="flex items-center gap-1 w-full"
    >
      <RadioButton
        v-model="model"
        :input-id="option.value"
        :name="option.value"
        :value="option.value"
        :pt="radioButtonPassthrough"
      />
      <label
        class="text-base-priority text-xs truncate text-ellipsis"
        :for="option.value"
      >
        {{
          $t(
            `label.${option.label}-${site.getRegionCode}`,
            `label.${option.label}`,
          )
        }}
      </label>
    </div>
  </div>
</template>
